import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import OutsideClickHandler from 'react-outside-click-handler'
import { ReactComponent as MenuIcon } from 'resources/svg/menu-icon.svg'
import { MenuDropdown, SmallMenuProvider } from './components/MenuDropdown'
import { Wrapper } from './components/Styled'

export const SmallMenu = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    setIsMenuVisible(false)
  }, [pathname])

  return (
    <OutsideClickHandler
      onOutsideClick={() => setIsMenuVisible(false)}
    >
      <Wrapper>
        <SmallMenuProvider
          isMenuVisible={isMenuVisible}
        >
          <button
            type='button'
            onClick={() => setIsMenuVisible(!isMenuVisible)}
            className={`menu-icon ${isMenuVisible && 'menu-open'}`}
          >
            <MenuIcon />
          </button>
          {isMenuVisible && (
            <MenuDropdown />
          )}
        </SmallMenuProvider>
      </Wrapper>
    </OutsideClickHandler>
  )
}
